/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const WorkforceCreate = () => {
  const { workforceApi } = apiPath;
  const { servicesWorkforceList } = RoutePath;
  const navigate = useNavigate();

  // const data = [
  //   {
  //     elementType: "input",
  //     label: "Banner Title",
  //     type: "Text",
  //     name: "Banner_Title",
  //     required: false,
  //   },
  //   {
  //     elementType: "input",
  //     label: "Content Title",
  //     type: "Text",
  //     name: "Content_Title",
  //     required: false,
  //   },
  //   {
  //     elementType: "input",
  //     label: "Para Title",
  //     type: "Text",
  //     name: "Para_Title",
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Para description 1",
  //     type: "Text",
  //     name: "Para_Desc_1",
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Para description 2",
  //     type: "Text",
  //     name: "Para_Desc_2",
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Banner description",
  //     type: "Text",
  //     name: "Banner_Description",
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "service detail list",
  //     type: "Text",
  //     name: "service_detail_list",
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Content Image`,
  //     name: "Content_Image",
  //     type: "file",
  //     fullCol: true,
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Content Image 2`,
  //     name: "Content_Image2",
  //     type: "file",
  //     fullCol: true,
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Banner Image`,
  //     name: "Banner_image",
  //     type: "file",
  //     fullCol: true,
  //     required: false,
  //   },
  // ];
  const data = [
    // # 1 
    {
      elementType: "input",
      label: "Workforce Title",
      type: "Text",
      name: "Content_Title",
      required: false,
    },
    // # 2
    {
      elementType: "file",
      label: `Workforce Thumbnail`,
      name: "Content_Image",
      type: "file",
      fullCol: true,
      required: false,
    },
    // # 3 
    {
      elementType: "file",
      label: `Workforce Banner`,
      name: "Banner_image",
      type: "file",
      fullCol: true,
      required: false,
    },
    // # 4
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "Banner_Title",
      required: false,
    },
    // # 5 
    {
      elementType: "textField",
      label: "Banner description",
      type: "Text",
      name: "Banner_Description",
      required: false,
    },
    // # 6 
    {
      elementType: "richTextEditor",
      label: "Service Details",
      type: "richTextEditor",
      name: "service_detail_list",
      required: false,
    },
  ];

  const update = async (data) => {
    const { Banner_image, Content_Image, Content_Image2, ...rest } = data;
    rest.Banner_image = {
      url: Banner_image,
    };
    rest.Content_Image = {
      url: Content_Image,
    };
    rest.Content_Image2 = {
      url: Content_Image2,
    };
    rest.identifier = data.Banner_Title;
    rest.Slug = data.Banner_Title;
    rest.Type = "content";

    const res = await updateData(workforceApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + servicesWorkforceList;
      }, 600);

    }
  };

  return (
    <div>
      <div className="md:pl-8 my-4 mb-8">
        <h1 className="font-oswald font-bold text-xl md:text-2xl -mb-10 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new workforce
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default WorkforceCreate;
